var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn10(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.87,26.72v-5A1.68,1.68,0,0,0,60.2,20H53.51a1.68,1.68,0,0,0-1.67,1.68v5a1.67,1.67,0,0,0-1.67,1.67v10a5,5,0,0,0,5,5V54.29a5.84,5.84,0,0,1-5.85,5.84h0a5.86,5.86,0,0,1-5.85-5.84V18.34a11.82,11.82,0,1,0-23.64,0v1.58H13.71a7.26,7.26,0,0,0-7.25,7.25V48.34a15.06,15.06,0,1,0,30.11,0V27.17a7.26,7.26,0,0,0-7.25-7.25H23.19V18.34a8.48,8.48,0,0,1,17,0v36a9.2,9.2,0,0,0,9.19,9.19h0a9.18,9.18,0,0,0,9.19-9.19V43.44a5,5,0,0,0,5-5v-10A1.67,1.67,0,0,0,61.87,26.72ZM33.22,48.34a11.71,11.71,0,1,1-23.41,0V40H33.22Zm-3.9-25.07a3.91,3.91,0,0,1,3.9,3.9v9.47H9.81V27.17a3.91,3.91,0,0,1,3.9-3.9Zm25.86.11h3.35v3.34H55.18Zm5,15.05a1.67,1.67,0,0,1-1.67,1.67H55.19a1.67,1.67,0,0,1-1.67-1.67V30.07h6.67Zm-40.35-6.8V28.28a1.67,1.67,0,1,1,3.34,0v3.35a1.67,1.67,0,1,1-3.34,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn10);
export default __webpack_public_path__ + "static/media/icn_10.dca92a21f3b66061cb1632d391bd3c71.svg";
export { ForwardRef as ReactComponent };